import '../assets/css/ExperienceSection.css';

const ExperienceSection = () => {
    return (
        <div>
            {/* Experience Cards Section */}
            <section className="feature-cards">
                <div className="container">
                    <div className="card">
                        <div className="card-icon-container">
                            <div className="card-icon">
                                <i className="fas fa-gem" />
                            </div>
                        </div>
                        <div className="card-content">
                            <h2>Exclusive Experiences</h2>
                            <p>Stay in handpicked villas, resorts, and homestays across Maharashtra and Pattaya, Thailand.</p>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-icon-container">
                            <div className="card-icon">
                                <i className="fas fa-user-check" />
                            </div>
                        </div>
                        <div className="card-content">
                            <h2>Tailored Stays</h2>
                            <p>Reach out for custom quotes and personalized staycation plans.</p>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-icon-container">
                            <div className="card-icon">
                                <i className="fas fa-envelope" />
                            </div>
                        </div>
                        <div className="card-content">
                            <h2>Contact Us</h2>
                            <p>Looking for a customized quote or assistance? Reach out to us at <a href="mailto:info@lsqstays.com">info@lsqstays.com</a></p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default ExperienceSection;